import React from "react";
import { Dropdown, Space, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { UI_COLORS } from "../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

/**
 * Component for selecting a tenant (Dropdown version)
 */
function TenantSelector({ tenants, selectedTenant, onTenantSelect }) {
  if (!tenants || tenants.length === 0) {
    return null;
  }

  // Preparazione degli items per la dropdown
  const items = tenants.map((tenant) => ({
    key: tenant.name,
    label: (
      <span>
        {tenant.name} {tenant.info ? `- ${tenant.info}` : ""}
      </span>
    ),
    onClick: () => onTenantSelect(tenant),
  }));

  // Se c'è un tenant selezionato, mostra il suo nome, altrimenti "Select tenant"
  const dropdownText = selectedTenant ? (
    <span>
      {selectedTenant.name}{" "}
      {selectedTenant.info ? `- ${selectedTenant.info}` : ""}
    </span>
  ) : (
    "Select tenant"
  );

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Button type="text" style={{ color: "white" }}>
        <Space>
          {dropdownText}
          <FontAwesomeIcon icon={faCaretDown} style={{ fontSize: 20 }} />
        </Space>
      </Button>
    </Dropdown>
  );
}

export default TenantSelector;
